import React, { Fragment } from 'react';
import { Link } from 'react-router-dom'
import Header6 from '../../components/header6/Header6';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/Help-Desk-Components/Footer/Footer';

const TermsPage = () => {
    return (
        <Fragment>
            <div className='help_desk'>
                <Header6 />

                {/* Page Header */}
                <section style={{
                    background: 'linear-gradient(135deg, #4b5563 0%, #374151 50%, #1f2937 100%)',
                    paddingTop: '140px',
                    paddingBottom: '80px',
                    position: 'relative',
                    overflow: 'hidden'
                }}>
                    {/* Decorative elements */}
                    <div style={{
                        position: 'absolute',
                        top: '-100px',
                        right: '-100px',
                        width: '300px',
                        height: '300px',
                        background: 'radial-gradient(circle, rgba(59, 130, 246, 0.1) 0%, transparent 70%)',
                        borderRadius: '50%',
                        pointerEvents: 'none'
                    }}></div>

                    <div className="container">
                        <div style={{ maxWidth: '800px' }}>
                            <span className="section-badge" style={{
                                background: 'rgba(59, 130, 246, 0.15)',
                                borderColor: 'rgba(59, 130, 246, 0.3)',
                                color: '#93c5fd',
                                marginBottom: '20px',
                                display: 'inline-flex'
                            }}>
                                Legal
                            </span>
                            <h1 style={{
                                fontSize: '3rem',
                                fontWeight: '800',
                                color: 'white',
                                marginBottom: '16px',
                                lineHeight: '1.2'
                            }}>
                                Terms & Conditions
                            </h1>
                            <p style={{
                                fontSize: '1.125rem',
                                color: 'rgba(255, 255, 255, 0.7)',
                                marginBottom: '8px'
                            }}>
                                Please read these terms carefully before using our services.
                            </p>
                            <span style={{
                                fontSize: '0.875rem',
                                color: 'rgba(255, 255, 255, 0.5)'
                            }}>
                                Last updated: February 2nd, 2026
                            </span>
                        </div>
                    </div>
                </section>

                {/* Content Section */}
                <section style={{
                    background: '#ffffff',
                    padding: '80px 0'
                }}>
                    <div className="container">
                        <div style={{ maxWidth: '800px', margin: '0 auto' }}>

                            <div style={{ marginBottom: '48px' }}>
                                <h2 style={{
                                    fontSize: '1.5rem',
                                    fontWeight: '700',
                                    color: '#1f2937',
                                    marginBottom: '16px'
                                }}>Copyright and Intellectual Property</h2>
                                <p style={{ color: '#4b5563', lineHeight: '1.8', marginBottom: '16px' }}>
                                    All content on this website, including text, graphics, logos, and trademarks, is the intellectual property of SaaS Watch and is protected by copyright, trademark, and other relevant laws. Unauthorized use, reproduction, or distribution of this material may violate these laws, leading to potential legal consequences.
                                </p>
                                <p style={{ color: '#4b5563', lineHeight: '1.8' }}>
                                    Images on this website may include licensed stock photos, to which SaaS Watch does not claim copyright ownership. All other trademarks and trade names are the properties of their respective owners.
                                </p>
                            </div>

                            <div style={{ marginBottom: '48px' }}>
                                <h2 style={{
                                    fontSize: '1.5rem',
                                    fontWeight: '700',
                                    color: '#1f2937',
                                    marginBottom: '16px'
                                }}>Website Usage Terms</h2>
                                <p style={{ color: '#4b5563', lineHeight: '1.8', marginBottom: '16px' }}>
                                    By accessing this website, you agree to comply with the following terms. You must not reproduce, modify, or distribute any content—including text, images, graphics, videos, and audio—for public or commercial use without authorization.
                                </p>
                                <p style={{ color: '#4b5563', lineHeight: '1.8', marginBottom: '16px' }}>
                                    Additionally, users must not submit or transmit any unlawful, abusive, defamatory, or otherwise offensive material via this website. Contact information found here must not be used for unsolicited or promotional communications.
                                </p>
                                <p style={{ color: '#4b5563', lineHeight: '1.8' }}>
                                    This website may contain links to external sites. SaaS Watch disclaims any responsibility for the content or privacy practices of third-party sites accessed through such links.
                                </p>
                            </div>

                            <div style={{ marginBottom: '48px' }}>
                                <h2 style={{
                                    fontSize: '1.5rem',
                                    fontWeight: '700',
                                    color: '#1f2937',
                                    marginBottom: '16px'
                                }}>Software and Services</h2>
                                <p style={{ color: '#4b5563', lineHeight: '1.8' }}>
                                    Our services, provided on an "as-is" and "as-available" basis, are governed by legally binding agreements that outline specific terms of service. You must give express consent to these terms to initiate service, making the agreement binding on both parties.
                                </p>
                            </div>

                            <div style={{ marginBottom: '48px' }}>
                                <h2 style={{
                                    fontSize: '1.5rem',
                                    fontWeight: '700',
                                    color: '#1f2937',
                                    marginBottom: '16px'
                                }}>Personal Information Policy</h2>
                                <p style={{ color: '#4b5563', lineHeight: '1.8' }}>
                                    SaaS Watch adheres to ethical business practices and safeguards your personal information according to our <Link to="/privacy-policy" style={{ color: '#3b82f6', textDecoration: 'underline' }}>Privacy Policy</Link>, which you should review for detailed information.
                                </p>
                            </div>

                            <div style={{ marginBottom: '48px' }}>
                                <h2 style={{
                                    fontSize: '1.5rem',
                                    fontWeight: '700',
                                    color: '#1f2937',
                                    marginBottom: '16px'
                                }}>Disclaimer</h2>
                                <p style={{ color: '#4b5563', lineHeight: '1.8', marginBottom: '16px' }}>
                                    Information on this website is provided in good faith and sourced from reliable providers. However, it may contain inaccuracies or typographical errors. SaaS Watch makes no express or implied warranties regarding the information, products, or services available on this site.
                                </p>
                                <p style={{ color: '#4b5563', lineHeight: '1.8' }}>
                                    SaaS Watch disclaims all warranties, including those related to fitness for a particular purpose. Usage of any services or material through this site is at the user's own discretion and risk.
                                </p>
                            </div>

                            <div style={{ marginBottom: '48px' }}>
                                <h2 style={{
                                    fontSize: '1.5rem',
                                    fontWeight: '700',
                                    color: '#1f2937',
                                    marginBottom: '16px'
                                }}>Limitation of Liability</h2>
                                <p style={{ color: '#4b5563', lineHeight: '1.8' }}>
                                    SaaS Watch disclaims liability for any damages, including lost data or profits, regardless of foreseeability or prior notification. This limitation may not apply in jurisdictions that prohibit exclusion of liability.
                                </p>
                            </div>

                            <div style={{
                                background: '#f3f4f6',
                                borderRadius: '16px',
                                padding: '32px',
                                marginTop: '48px'
                            }}>
                                <h2 style={{
                                    fontSize: '1.25rem',
                                    fontWeight: '700',
                                    color: '#1f2937',
                                    marginBottom: '12px'
                                }}>Questions?</h2>
                                <p style={{ color: '#4b5563', lineHeight: '1.8' }}>
                                    If you have any questions about these Terms & Conditions, please <Link to="/#contact" style={{ color: '#3b82f6', textDecoration: 'underline' }}>contact us</Link>.
                                </p>
                            </div>

                        </div>
                    </div>
                </section>

                <Scrollbar />
            </div>
            <Footer />
        </Fragment>
    )
};

export default TermsPage;
